import { CollectionReference, collection, getDocs, getFirestore } from 'firebase/firestore';

import { toast } from '@/components/Toaster/Toast';

import { safePromise } from '@/utils/safePromise';

import { SessionStatus } from '@/models';

export interface SessionTypeInDatabase {
  id: string;
  Tests: string[];
  createdBy: string;
  dateCreated: string;
  lastUpdated: string;
  numberOfSensors: string;
  status: SessionStatus;
  title: string;
}

/**
 * Fetches ALL session types from the database
 */
export const getFirebaseSessionTypes = async (): Promise<SessionTypeInDatabase[] | undefined> => {
  const firestore = getFirestore();
  const sessionTypeRef = collection(firestore, '_sessionTypes') as CollectionReference<SessionTypeInDatabase>;

  // Use safePromise to handle the error
  const [querySnapshot, error] = await safePromise(getDocs(sessionTypeRef));

  if (error) {
    toast({
      variant: 'error',
      title: 'Something went wrong',
      description: 'Please try again later',
    });

    return undefined;
  }

  if (querySnapshot.empty) {
    toast({
      variant: 'error',
      title: 'No session Types found',
      description: 'Please contact support',
    });

    return undefined;
  }

  return querySnapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
};
